<template>
  <div class="service-summary">
    <div class="card" v-for="card in cards" :key="card.title">
      <div class="left">
        <img :src="card.src" />
      </div>
      <div class="right">
        <p class="title">{{ card.title }}</p>
        <div class="describe" v-if="card.type === 'standard'">
          <p>机房监控</p>
          <p>能效分析</p>
          <p>报警管理</p>
          <p>系统配置</p>
        </div>
        <div class="describe" v-if="card.type === 'experience'">
          <p>标准报表</p>
          <p>设备生命周期管理</p>
          <p>工单管理</p>
        </div>
        <div class="price">
          <p v-if="card.type === 'standard'" class="prefix">20,000</p>
          <p v-if="card.type === 'standard'" class="suffix">元/起</p>
          <p v-if="card.type === 'experience'" class="des">50,000</p>
          <p v-if="card.type === 'experience'" class="suffix">元/起</p>
        </div>
        <div v-if="card.type === 'standard'" class="original-price">
          限时减免：<span>20,000元</span>
        </div>
        <div v-if="card.type === 'experience'" class="original-price">
          限时减免：<span>50,000元</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "summary-machine-room",
  setup() {
    const cards = ref([
      {
        src: require("@/assets/img/standard.jpg"),
        type: "standard",
        title: "基础版",
        content: [""]
      },
      {
        src: require("@/assets/img/experience.jpg"),
        type: "experience",
        title: "高级版",
        content: [""]
      }
    ]);
    return {
      cards
    };
  }
};
</script>

<style lang="less" scoped>
.service-summary {
  display: flex;
  & > :not(:last-child) {
    margin-right: 16px;
  }
  .card {
    display: flex;
    width: 100%;
    padding: 24px;
    border: 1px solid #e5e6eb;
    .left {
      width: 156px;
      margin-right: 24px;
      img {
        width: 156px;
        height: 156px;
      }
    }
    .right {
      text-align: left;
      .title {
        margin-bottom: 16px;
        color: #1d2129;
        font-size: 24px;
        line-height: 32px;
      }
      .describe {
        display: flex;
        flex-wrap: wrap;
        & > :nth-child(2n) {
          margin-bottom: 14px;
        }
        & > p {
          width: 50%;
          line-height: 22px;
        }
      }
      .price {
        display: flex;
        margin-top: 15px;
        color: #fc8c23;
        .prefix {
          font-size: 32px;
          line-height: 40px;
        }
        .suffix {
          margin-top: 11px;
          margin-left: 4px;
          font-size: 14px;
        }
        .des {
          font-size: 24px;
          line-height: 33px;
        }
      }
      .original-price {
        margin-top: 8px;
        color: #c9cdd4;
        line-height: 22px;
        span {
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>
